var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineAdvantages1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2124,
    height: 66,
    viewBox: "0 0 2124 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3052_1044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2088 47.9585H1833.1L1779.81 1.66797L0.736572 2.95875",
    stroke: "url(#paint0_linear_3052_1044)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2124 29.9609H2088V65.9609H2124V29.9609Z",
    fill: "#71253C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3052_1044",
    x1: 1407.68,
    y1: 25.4628,
    x2: 2079.86,
    y2: 25.4628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#031233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71253C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3052_1044"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2124,
    height: 66,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineAdvantages1);
export default __webpack_public_path__ + "static/media/line-Advantages1.ded4ac7dc1a755549e6967131dafa499.svg";
export { ForwardRef as ReactComponent };